export const sizes = {
  fhd: 1920,
  hd: 1280,
  desktop: 992,
  tablet: 769,
  phone: 576
}
